import React, { useEffect, useState } from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { Card } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { Modal } from '../components/ui/Modal';
import { Pagination } from '../components/ui/Pagination';
import { useSearch } from '../hooks/useSearch';
import { useFilters } from '../hooks/useFilters';
import { usePagination } from '../hooks/usePagination';
import { ColumnCustomizer } from '../components/ColumnCustomizer';
import { Textarea } from '../components/ui/Textarea';
import { DatePicker } from '../components/ui/DatePicker';
import { Tooltip } from '../components/ui/Tooltip';
import { Plus, Filter, Download, Eye, Edit, Search, AlertTriangle, Lightbulb, Mail, X, Save, CheckCircle2, Trash2, AlertCircle, Upload, Image as ImageIcon } from 'lucide-react';
import { useNotifications } from '../contexts/NotificationContext';
import { motion, AnimatePresence } from 'framer-motion';
const initialNCData = Array.from({
  length: 50
}, (_, i) => ({
  id: String(i + 1),
  number: `NC-2024/${String(i + 1).padStart(3, '0')}`,
  type: i % 3 === 0 ? 'Non conformità maggiore' : i % 3 === 1 ? 'Non conformità minore' : 'Osservazione',
  origin: i % 3 === 0 ? 'Interna' : i % 3 === 1 ? 'Cliente (reclamo)' : 'Fornitore',
  description: 'Descrizione non conformità...',
  date: '2024-05-10',
  responsible: i % 3 === 0 ? 'Lorenzo' : i % 3 === 1 ? 'Alessio' : 'Gian Franco',
  status: i % 3 === 0 ? 'Aperta' : i % 3 === 1 ? 'Sospesa' : 'Chiusa'
}));
const initialImprovementsData = Array.from({
  length: 20
}, (_, i) => ({
  id: String(i + 1),
  number: `MIG-2024/${String(i + 1).padStart(3, '0')}`,
  subject: `Miglioramento processo ${i + 1}`,
  description: 'Proposta miglioramento processo...',
  date: '2024-05-15',
  status: i % 3 === 0 ? 'In valutazione' : i % 3 === 1 ? 'Sospesa' : 'Approvato',
  responsible: i % 2 === 0 ? 'Alessio' : 'Lorenzo'
}));
const ncColumnsConfig = [{
  key: 'number',
  label: 'Codice'
}, {
  key: 'type',
  label: 'Tipologia'
}, {
  key: 'origin',
  label: 'Origine'
}, {
  key: 'description',
  label: 'Descrizione'
}, {
  key: 'date',
  label: 'Data rilev.'
}, {
  key: 'responsible',
  label: 'Responsabile'
}, {
  key: 'status',
  label: 'Stato'
}, {
  key: 'actions',
  label: 'Azioni'
}];
const impColumnsConfig = [{
  key: 'number',
  label: 'Codice'
}, {
  key: 'subject',
  label: 'Oggetto'
}, {
  key: 'description',
  label: 'Descrizione'
}, {
  key: 'date',
  label: 'Data proposta'
}, {
  key: 'responsible',
  label: 'Responsabile'
}, {
  key: 'status',
  label: 'Stato'
}, {
  key: 'actions',
  label: 'Azioni'
}];
export function NonConformitiesPage() {
  const [activeTab, setActiveTab] = useState<'nc' | 'improvements'>('nc');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [showFilters, setShowFilters] = useState(false);
  // Columns state
  const [visibleColumnsNC, setVisibleColumnsNC] = useState(ncColumnsConfig.map(c => c.key));
  const [visibleColumnsImp, setVisibleColumnsImp] = useState(impColumnsConfig.map(c => c.key));
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [formData, setFormData] = useState<any>({});
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<any>(null);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const {
    addNotification
  } = useNotifications();
  // View modal state
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewItem, setViewItem] = useState<any>(null);
  // NC Hooks
  const {
    filters: filtersNC,
    setFilter: setFilterNC,
    clearFilters: clearFiltersNC,
    filteredData: filterResultNC
  } = useFilters(initialNCData);
  const {
    searchTerm: searchTermNC,
    setSearchTerm: setSearchTermNC,
    filteredData: searchResultNC
  } = useSearch(filterResultNC, ['number', 'description', 'type']);
  const {
    currentPage: currentPageNC,
    totalPages: totalPagesNC,
    paginatedData: paginatedDataNC,
    goToPage: goToPageNC,
    pageSize: pageSizeNC,
    setPageSize: setPageSizeNC,
    totalItems: totalItemsNC,
    setCurrentPage: setCurrentPageNC
  } = usePagination(searchResultNC);
  // Improvements Hooks
  const {
    filters: filtersImp,
    setFilter: setFilterImp,
    clearFilters: clearFiltersImp,
    filteredData: filterResultImp
  } = useFilters(initialImprovementsData);
  const {
    searchTerm: searchTermImp,
    setSearchTerm: setSearchTermImp,
    filteredData: searchResultImp
  } = useSearch(filterResultImp, ['number', 'description', 'subject']);
  const {
    currentPage: currentPageImp,
    totalPages: totalPagesImp,
    paginatedData: paginatedDataImp,
    goToPage: goToPageImp,
    pageSize: pageSizeImp,
    setPageSize: setPageSizeImp,
    totalItems: totalItemsImp,
    setCurrentPage: setCurrentPageImp
  } = usePagination(searchResultImp);
  useEffect(() => {
    setCurrentPageNC(1);
  }, [filtersNC, searchTermNC]);
  useEffect(() => {
    setCurrentPageImp(1);
  }, [filtersImp, searchTermImp]);
  const handleEdit = (item: any) => {
    setSelectedItem(item);
    setFormData(item);
    setIsModalOpen(true);
  };
  const handleView = (item: any) => {
    setViewItem(item);
    setIsViewModalOpen(true);
  };
  const handleViewToEdit = () => {
    setIsViewModalOpen(false);
    handleEdit(viewItem);
  };
  const handleCreate = () => {
    setSelectedItem(null);
    if (activeTab === 'nc') {
      const nextNumber = `NC-2024/${String(initialNCData.length + 1).padStart(3, '0')}`;
      setFormData({
        number: nextNumber,
        status: 'Aperta'
      });
    } else {
      const nextNumber = `MIG-2024/${String(initialImprovementsData.length + 1).padStart(3, '0')}`;
      setFormData({
        number: nextNumber,
        status: 'In valutazione'
      });
    }
    setIsModalOpen(true);
  };
  const handleDelete = (item: any) => {
    setItemToDelete(item);
    setShowDeleteDialog(true);
  };
  const confirmDelete = () => {
    setDeleteSuccess(true);
    setTimeout(() => {
      setDeleteSuccess(false);
      setShowDeleteDialog(false);
      setItemToDelete(null);
      addNotification('success', 'Eliminato', 'Elemento eliminato con successo');
    }, 1500);
  };
  const handleSave = () => {
    setSaveSuccess(true);
    setTimeout(() => {
      setSaveSuccess(false);
      setIsModalOpen(false);
      addNotification('success', activeTab === 'nc' ? 'Non conformità salvata' : 'Miglioramento salvato', 'I dati sono stati salvati correttamente.');
    }, 1500);
  };
  const handleSendReport = () => {
    addNotification('success', 'Report inviato', 'Il report Non conformità è stato inviato al cliente.');
    setIsReportModalOpen(false);
  };
  const hasActiveFiltersNC = Object.keys(filtersNC).some(k => filtersNC[k]);
  const hasActiveFiltersImp = Object.keys(filtersImp).some(k => filtersImp[k]);
  const showOriginSelect = formData.type === 'Non conformità maggiore' || formData.type === 'Non conformità minore';
  return <Layout data-id="element-5230" data-mp="2pgfgn2o6i0la">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4" data-id="element-5231" data-mp="2pgp007epx9i0">
        <div data-id="element-5232" data-mp="2u9rssdbo8ex5">
          <h1 className="text-3xl font-bold text-seform-navy" data-id="element-5233" data-mp="2uabbvxd259cr">
            Non conformità e miglioramenti
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-5234" data-mp="21rw8cn54pnt7">
            Gestione NC, reclami e piani di miglioramento.
          </p>
        </div>
        <div className="flex gap-3" data-id="element-5235" data-mp="v3sapems8xet">
          <div className="bg-slate-100 p-1 rounded-xl flex items-center" data-id="element-5236" data-mp="v4tviatloy9q">
            <button onClick={() => setActiveTab('nc')} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${activeTab === 'nc' ? 'bg-white text-seform-navy shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-5237" data-mp="q6sd7s4012zb">
              Non conformità
            </button>
            <button onClick={() => setActiveTab('improvements')} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${activeTab === 'improvements' ? 'bg-white text-seform-navy shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-5238" data-mp="1e1mr4dq8qb78">
              Miglioramenti
            </button>
          </div>
          <Button variant="flat" color="secondary" startContent={<Download className="h-4 w-4" data-id="element-5240" data-mp="1ssvmz4kqksst" />} data-id="element-5239" data-mp="1wt5recsvrb5k">
            Esporta
          </Button>
          <Button onClick={handleCreate} startContent={<Plus className="h-4 w-4" data-id="element-5242" data-mp="2bejj83qkfwfk" />} data-id="element-5241" data-mp="2bgw2qlbz2euq">
            {activeTab === 'nc' ? 'Non conformità' : 'Nuovo miglioramento'}
          </Button>
        </div>
      </div>

      {activeTab === 'nc' ? <>
          <Card className="mb-6" noPadding data-id="element-5243" data-mp="27f0zhbahdreb">
            <div className="p-4 flex flex-col gap-4" data-id="element-5244" data-mp="27dpxnh0litpu">
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-5245" data-mp="1sq4whsna74kk">
                <div className="flex-1" data-id="element-5246" data-mp="1sotrjpi3nqrv">
                  <Input placeholder="Cerca non conformità..." startContent={<Search className="h-4 w-4" data-id="element-5248" data-mp="1jpqa0pykzjfh" />} value={searchTermNC} onChange={e => setSearchTermNC(e.target.value)} fullWidth data-id="element-5247" data-mp="1xglapeyxeu7z" />
                </div>
                <div className="flex gap-2" data-id="element-5249" data-mp="19sbt6p8qwsmn">
                  <Button variant={showFilters ? 'solid' : 'flat'} color="secondary" onClick={() => setShowFilters(!showFilters)} startContent={<Filter className="h-4 w-4" data-id="element-5251" data-mp="3vxw4mlnliept" />} data-id="element-5250" data-mp="19tmwyp26y0dr">
                    Filtri{' '}
                    {hasActiveFiltersNC && <Badge variant="primary" size="sm" className="ml-1" data-id="element-5252" data-mp="3hzeksz0t9md6">
                        {Object.keys(filtersNC).filter(k => filtersNC[k]).length}
                      </Badge>}
                  </Button>
                  <ColumnCustomizer columns={ncColumnsConfig} visibleColumns={visibleColumnsNC} onColumnChange={setVisibleColumnsNC} pageKey="nc" lockedColumns={['number']} data-id="element-5253" data-mp="jfxsx3n63yk0" />
                </div>
              </div>

              {showFilters && <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 pt-4 border-t border-slate-100 animate-in fade-in slide-in-from-top-2" data-id="element-5254" data-mp="1278npvw0kvh6">
                  <Select label="Stato" value={filtersNC.status || ''} onChange={e => setFilterNC('status', e.target.value)} options={[{
              value: '',
              label: 'Tutti'
            }, {
              value: 'Aperta',
              label: 'Aperta'
            }, {
              value: 'Sospesa',
              label: 'Sospesa'
            }, {
              value: 'Chiusa',
              label: 'Chiusa'
            }]} data-id="element-5255" data-mp="2mv1993kyb9lb" />
                  <Select label="Tipologia" value={filtersNC.type || ''} onChange={e => setFilterNC('type', e.target.value)} options={[{
              value: '',
              label: 'Tutte'
            }, {
              value: 'Non conformità maggiore',
              label: 'Non conformità maggiore'
            }, {
              value: 'Non conformità minore',
              label: 'Non conformità minore'
            }, {
              value: 'Osservazione',
              label: 'Osservazione'
            }]} data-id="element-5256" data-mp="3ocijxpev2eqg" />
                  <div className="col-span-full flex justify-end" data-id="element-5257" data-mp="2c3137qshzzof">
                    <Button variant="flat" color="danger" size="sm" onClick={clearFiltersNC} startContent={<X className="h-4 w-4" data-id="element-5259" data-mp="1jk3z57qvjdr5" />} data-id="element-5258" data-mp="1endhifzf8a3m">
                      Resetta filtri
                    </Button>
                  </div>
                </div>}
            </div>
          </Card>

          <Card noPadding className="overflow-hidden" data-id="element-5260" data-mp="1248bj8kjrm91">
            <div className="overflow-x-auto" data-id="element-5261" data-mp="126ujh9bco3rs">
              <table className="w-full text-left border-collapse table-auto" data-id="element-5262" data-mp="y3xxr9qijrjm">
                <thead data-id="element-5263" data-mp="t3tg3gdvcqrt">
                  <tr className="bg-slate-50/50 border-b border-slate-100 text-xs uppercase tracking-wider text-slate-500 font-semibold" data-id="element-5264" data-mp="t4d1j72q9xal">
                    {ncColumnsConfig.filter(c => visibleColumnsNC.includes(c.key)).map(col => <th key={col.key} className={`px-4 py-4 ${col.key === 'actions' ? 'text-left pr-6' : ''}`} data-id="element-5265" data-mp="efp3mu5etbhh">
                          {col.label}
                        </th>)}
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100" data-id="element-5266" data-mp="25i1lg66qxx0m">
                  {paginatedDataNC.map(item => <tr key={item.id} className="hover:bg-slate-50/80 transition-colors group" data-id="element-5267" data-mp="29hk5kzqqu42e">
                      {visibleColumnsNC.includes('number') && <td className="px-4 py-4 font-mono text-xs text-slate-500" data-id="element-5268" data-mp="1lsr6wviqli43">
                          {item.number}
                        </td>}
                      {visibleColumnsNC.includes('type') && <td className="px-4 py-4" data-id="element-5269" data-mp="1ct4f91ft7qo8">
                          <Badge variant={item.type === 'Non conformità maggiore' ? 'danger' : item.type === 'Non conformità minore' ? 'warning' : 'info'} data-id="element-5270" data-mp="1cufkl5owl6hg">
                            {item.type}
                          </Badge>
                        </td>}
                      {visibleColumnsNC.includes('origin') && <td className="px-4 py-4 text-sm text-slate-600" data-id="element-5271" data-mp="3v3a4wfncqd7i">
                          {item.origin || '-'}
                        </td>}
                      {visibleColumnsNC.includes('description') && <td className="px-4 py-4 text-sm text-slate-600 max-w-xs truncate" data-id="element-5272" data-mp="3vxk7qn9fhmu">
                          {item.description}
                        </td>}
                      {visibleColumnsNC.includes('date') && <td className="px-4 py-4 text-sm text-slate-600" data-id="element-5273" data-mp="drhey9q38aa0">
                          {item.date}
                        </td>}
                      {visibleColumnsNC.includes('responsible') && <td className="px-4 py-4 text-sm text-slate-600" data-id="element-5274" data-mp="ikkjs1mwosdf">
                          {item.responsible}
                        </td>}
                      {visibleColumnsNC.includes('status') && <td className="px-4 py-4" data-id="element-5275" data-mp="sgno9e58d33j">
                          <Badge variant={item.status === 'Aperta' ? 'danger' : item.status === 'Sospesa' ? 'warning' : 'success'} data-id="element-5276" data-mp="xh1t6nbjbwxc">
                            {item.status}
                          </Badge>
                        </td>}
                      {visibleColumnsNC.includes('actions') && <td className="px-4 py-4 pr-6" data-id="element-5277" data-mp="1l52ylndf2x8j">
                          <div className="flex items-center gap-1" data-id="element-5278" data-mp="1p9aqtuj32vbi">
                            <Tooltip content="Visualizza NC" data-id="element-5279" data-mp="39r1q40vdbmwj">
                              <Button variant="light" size="sm" className="!px-1" onClick={() => handleView(item)} data-id="element-5280" data-mp="39ofkw7vy9jhh">
                                <Eye className="h-4 w-4 text-slate-500" data-id="element-5281" data-mp="2vsbtemcgnp8p" />
                              </Button>
                            </Tooltip>
                            <Tooltip content="Invia report" data-id="element-5282" data-mp="3ofofywimfx20">
                              <Button variant="light" size="sm" className="!px-1" onClick={() => setIsReportModalOpen(true)} data-id="element-5283" data-mp="3og7xwd89ulg1">
                                <Mail className="h-4 w-4 text-blue-500" data-id="element-5284" data-mp="g17gcd6nqv6k" />
                              </Button>
                            </Tooltip>
                            <Tooltip content="Modifica NC" data-id="element-5285" data-mp="3fqzd4un9dcno">
                              <Button variant="light" size="sm" className="!px-1" onClick={() => handleEdit(item)} data-id="element-5286" data-mp="3fpehf1p7jno8">
                                <Edit className="h-4 w-4 text-seform-orange" data-id="element-5287" data-mp="3asfq0qwxhutq" />
                              </Button>
                            </Tooltip>
                            <Tooltip content="Elimina NC" data-id="element-5288" data-mp="7axh0g5f6hrq">
                              <Button variant="light" size="sm" className="!px-1" onClick={() => handleDelete(item)} data-id="element-5289" data-mp="7ae278b2g9hx">
                                <Trash2 className="h-4 w-4 text-red-500" data-id="element-5290" data-mp="2e0c3flp60gx5" />
                              </Button>
                            </Tooltip>
                          </div>
                        </td>}
                    </tr>)}
                </tbody>
              </table>
            </div>
            <div className="border-t border-slate-100" data-id="element-5291" data-mp="26jxgfpj8gd45">
              <Pagination currentPage={currentPageNC} totalPages={totalPagesNC} onPageChange={goToPageNC} totalItems={totalItemsNC} pageSize={pageSizeNC} onPageSizeChange={setPageSizeNC} data-id="element-5292" data-mp="2kgkoancq4nou" />
            </div>
          </Card>
        </> : <>
          <Card className="mb-6" noPadding data-id="element-5293" data-mp="21irnprpkopum">
            <div className="p-4 flex flex-col gap-4" data-id="element-5294" data-mp="21jjgkursc9h7">
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-5295" data-mp="1wsb7jzudaq4k">
                <div className="flex-1" data-id="element-5296" data-mp="1wqqdebbyt978">
                  <Input placeholder="Cerca miglioramenti..." startContent={<Search className="h-4 w-4" data-id="element-5298" data-mp="143nkbyq25qod" />} value={searchTermImp} onChange={e => setSearchTermImp(e.target.value)} fullWidth data-id="element-5297" data-mp="191xd62ob8f6t" />
                </div>
                <div className="flex gap-2" data-id="element-5299" data-mp="3rqtqbmlu4bx8">
                  <Button variant={showFilters ? 'solid' : 'flat'} color="secondary" onClick={() => setShowFilters(!showFilters)} startContent={<Filter className="h-4 w-4" data-id="element-5301" data-mp="j9p6f91yzupl" />} data-id="element-5300" data-mp="a90seecktucp">
                    Filtri{' '}
                    {hasActiveFiltersImp && <Badge variant="primary" size="sm" className="ml-1" data-id="element-5302" data-mp="e9t5jiokkje9">
                        {Object.keys(filtersImp).filter(k => filtersImp[k]).length}
                      </Badge>}
                  </Button>
                  <ColumnCustomizer columns={impColumnsConfig} visibleColumns={visibleColumnsImp} onColumnChange={setVisibleColumnsImp} pageKey="improvements" lockedColumns={['number']} data-id="element-5303" data-mp="2uzhzptbkyxrg" />
                </div>
              </div>

              {showFilters && <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 pt-4 border-t border-slate-100 animate-in fade-in slide-in-from-top-2" data-id="element-5304" data-mp="vrrw12h5dyii">
                  <Select label="Stato" value={filtersImp.status || ''} onChange={e => setFilterImp('status', e.target.value)} options={[{
              value: '',
              label: 'Tutti'
            }, {
              value: 'In valutazione',
              label: 'In valutazione'
            }, {
              value: 'Sospesa',
              label: 'Sospesa'
            }, {
              value: 'Approvato',
              label: 'Approvato'
            }, {
              value: 'Scartata',
              label: 'Scartata'
            }]} data-id="element-5305" data-mp="mrv48rzgojj8" />
                  <div className="col-span-full flex justify-end" data-id="element-5306" data-mp="1vter5wxptsqa">
                    <Button variant="flat" color="danger" size="sm" onClick={clearFiltersImp} startContent={<X className="h-4 w-4" data-id="element-5308" data-mp="2jpk7adxr80n7" />} data-id="element-5307" data-mp="2tgezs01lfwh3">
                      Resetta filtri
                    </Button>
                  </div>
                </div>}
            </div>
          </Card>

          <Card noPadding className="overflow-hidden" data-id="element-5309" data-mp="3c74z5eryh157">
            <div className="overflow-x-auto" data-id="element-5310" data-mp="37fwran69xnu5">
              <table className="w-full text-left border-collapse table-auto" data-id="element-5311" data-mp="37e3hx04a0pig">
                <thead data-id="element-5312" data-mp="3fpc8ioyq0jr8">
                  <tr className="bg-slate-50/50 border-b border-slate-100 text-xs uppercase tracking-wider text-slate-500 font-semibold" data-id="element-5313" data-mp="3fpvfxbqqvpr0">
                    {impColumnsConfig.filter(c => visibleColumnsImp.includes(c.key)).map(col => <th key={col.key} className={`px-4 py-4 ${col.key === 'actions' ? 'text-left pr-6' : ''}`} data-id="element-5314" data-mp="3tov6wq1qcgqc">
                          {col.label}
                        </th>)}
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100" data-id="element-5315" data-mp="bc5lsgkmf3a0">
                  {paginatedDataImp.map(item => <tr key={item.id} className="hover:bg-slate-50/80 transition-colors group" data-id="element-5316" data-mp="l88q9t2y3e04">
                      {visibleColumnsImp.includes('number') && <td className="px-4 py-4 font-mono text-xs text-slate-500" data-id="element-5317" data-mp="1mxyi70rodqts">
                          {item.number}
                        </td>}
                      {visibleColumnsImp.includes('subject') && <td className="px-4 py-4 text-sm font-medium text-slate-900" data-id="element-5318" data-mp="1wnqkkh60no8t">
                          {item.subject}
                        </td>}
                      {visibleColumnsImp.includes('description') && <td className="px-4 py-4 text-sm text-slate-600 max-w-xs truncate" data-id="element-5319" data-mp="z1kqqwb5wlns">
                          {item.description}
                        </td>}
                      {visibleColumnsImp.includes('date') && <td className="px-4 py-4 text-sm text-slate-600" data-id="element-5320" data-mp="1911w1cmi4xj8">
                          {item.date}
                        </td>}
                      {visibleColumnsImp.includes('responsible') && <td className="px-4 py-4 text-sm text-slate-600" data-id="element-5321" data-mp="2rx3v8b48nalp">
                          {item.responsible}
                        </td>}
                      {visibleColumnsImp.includes('status') && <td className="px-4 py-4" data-id="element-5322" data-mp="2i10g84oafhhc">
                          <Badge variant={item.status === 'Sospesa' ? 'warning' : 'info'} data-id="element-5323" data-mp="2myadu7ltyzg9">
                            {item.status}
                          </Badge>
                        </td>}
                      {visibleColumnsImp.includes('actions') && <td className="px-4 py-4 pr-6" data-id="element-5324" data-mp="35x4vppglcg0n">
                          <div className="flex items-center gap-1" data-id="element-5325" data-mp="35vlffyuxq4yv">
                            <Tooltip content="Visualizza miglioramento" data-id="element-5326" data-mp="3tlxt7qcv2vxd">
                              <Button variant="light" size="sm" className="!px-1" onClick={() => handleView(item)} data-id="element-5327" data-mp="28usvt9am4yj">
                                <Eye className="h-4 w-4 text-slate-500" data-id="element-5328" data-mp="73e1ypsxy8ru" />
                              </Button>
                            </Tooltip>
                            <Tooltip content="Modifica miglioramento" data-id="element-5329" data-mp="3u8v99bxtv0id">
                              <Button variant="light" size="sm" className="!px-1" onClick={() => handleEdit(item)} data-id="element-5330" data-mp="3pbd7c5i89ljv">
                                <Edit className="h-4 w-4 text-seform-orange" data-id="element-5331" data-mp="3finvvamog7oj" />
                              </Button>
                            </Tooltip>
                            <Tooltip content="Elimina miglioramento" data-id="element-5332" data-mp="36j0vms5op7x2">
                              <Button variant="light" size="sm" className="!px-1" onClick={() => handleDelete(item)} data-id="element-5333" data-mp="31kpmkjn7r1fw">
                                <Trash2 className="h-4 w-4 text-red-500" data-id="element-5334" data-mp="1r1edme24tf3b" />
                              </Button>
                            </Tooltip>
                          </div>
                        </td>}
                    </tr>)}
                </tbody>
              </table>
            </div>
            <div className="border-t border-slate-100" data-id="element-5335" data-mp="13cv5byj312b8">
              <Pagination currentPage={currentPageImp} totalPages={totalPagesImp} onPageChange={goToPageImp} totalItems={totalItemsImp} pageSize={pageSizeImp} onPageSizeChange={setPageSizeImp} data-id="element-5336" data-mp="139frt05241bx" />
            </div>
          </Card>
        </>}

      {/* View/Consultation Modal */}
      <Modal isOpen={isViewModalOpen} onClose={() => setIsViewModalOpen(false)} title={viewItem ? activeTab === 'nc' ? `Dettaglio non conformità — ${viewItem.number}` : `Dettaglio miglioramento — ${viewItem.number}` : ''} size="2xl" data-id="element-5337" data-mp="jlgdxgf74e2a">
        {viewItem && activeTab === 'nc' && <div className="space-y-8" data-id="element-5338" data-mp="3e724z3rydnti">
            <section data-id="element-5339" data-mp="3s48r98bvy4nh">
              <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-5340" data-mp="3s3fp6knvg3bo">
                <AlertTriangle className="h-4 w-4" data-id="element-5341" data-mp="3n5dwr94k2rnj" /> Dettagli non conformità
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5342" data-mp="5oe6r55zt5mq">
                <div data-id="element-5343" data-mp="r47yywprhm8">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-5344" data-mp="ql1cecikfni">
                    Codice
                  </label>
                  <p className="text-sm font-medium text-slate-900" data-id="element-5345" data-mp="aoipz2yacegn">
                    {viewItem.number}
                  </p>
                </div>
                <div data-id="element-5346" data-mp="td2m3vziwguh">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-5347" data-mp="taq6vql5gkl4">
                    Tipologia
                  </label>
                  <Badge variant={viewItem.type === 'Non conformità maggiore' ? 'danger' : viewItem.type === 'Non conformità minore' ? 'warning' : 'info'} data-id="element-5348" data-mp="katebdvn31ks">
                    {viewItem.type}
                  </Badge>
                </div>
                {(viewItem.type === 'Non conformità maggiore' || viewItem.type === 'Non conformità minore') && <div data-id="element-5349" data-mp="3nslbd6omubpu">
                    <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-5350" data-mp="3ns1ultapxtde">
                      Origine
                    </label>
                    <p className="text-sm font-medium text-slate-900" data-id="element-5351" data-mp="3str4h5m7g0zw">
                      {viewItem.origin || '-'}
                    </p>
                  </div>}
                <div data-id="element-5352" data-mp="3v3djjrmqoxy3">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-5353" data-mp="3v4op9wzqwfru">
                    Data rilevazione
                  </label>
                  <p className="text-sm font-medium text-slate-900" data-id="element-5354" data-mp="7yxeqlkszkdo">
                    {viewItem.date || '-'}
                  </p>
                </div>
                <div data-id="element-5355" data-mp="hwbueiywk54x">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-5356" data-mp="hvikj94nczik">
                    Responsabile
                  </label>
                  <p className="text-sm font-medium text-slate-900" data-id="element-5357" data-mp="mp4xl2eq35ew">
                    {viewItem.responsible || '-'}
                  </p>
                </div>
                <div data-id="element-5358" data-mp="vortx9slhl13">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-5359" data-mp="vpjnkf2mt8oq">
                    Stato
                  </label>
                  <Badge variant={viewItem.status === 'Aperta' ? 'danger' : viewItem.status === 'Sospesa' ? 'warning' : 'success'} data-id="element-5360" data-mp="1ar9o6ask2da1">
                    {viewItem.status}
                  </Badge>
                </div>
                <div className="col-span-full" data-id="element-5361" data-mp="1thrds6i3csr6">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-5362" data-mp="1tgg9m5kqhizj">
                    Descrizione
                  </label>
                  <p className="text-sm text-slate-700 bg-slate-50 rounded-lg p-3 border border-slate-100" data-id="element-5363" data-mp="1jqwth7oeo38d">
                    {viewItem.description || '-'}
                  </p>
                </div>
              </div>
            </section>

            {(viewItem.actionDescription || viewItem.actionResponsible || viewItem.actionDeadline) && <section data-id="element-5364" data-mp="5jgtextq4hx5">
                <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-5365" data-mp="5j72n80uu6qe">
                  <Lightbulb className="h-4 w-4" data-id="element-5366" data-mp="ah8n9xdxie3z" /> Azione correttiva
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5367" data-mp="3ry0aj2a32b7b">
                  {viewItem.actionDescription && <div className="col-span-full" data-id="element-5368" data-mp="qxi67iidyvi">
                      <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-5369" data-mp="3ixty7jq4fh9q">
                        Descrizione azione
                      </label>
                      <p className="text-sm text-slate-700 bg-slate-50 rounded-lg p-3 border border-slate-100" data-id="element-5370" data-mp="39074vs82rn68">
                        {viewItem.actionDescription}
                      </p>
                    </div>}
                  {viewItem.actionResponsible && <div data-id="element-5371" data-mp="176q3h6ajfijx">
                      <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-5372" data-mp="1c7ng73cs3ke1">
                        Responsabile azione
                      </label>
                      <p className="text-sm font-medium text-slate-900" data-id="element-5373" data-mp="2wnliyn85z84s">
                        {viewItem.actionResponsible}
                      </p>
                    </div>}
                  {viewItem.actionDeadline && <div data-id="element-5374" data-mp="31orgqzgolll6">
                      <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-5375" data-mp="31ngdd0r5eful">
                        Scadenza azione
                      </label>
                      <p className="text-sm font-medium text-slate-900" data-id="element-5376" data-mp="3bfm4675nyr87">
                        {viewItem.actionDeadline}
                      </p>
                    </div>}
                </div>
              </section>}

            <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-5377" data-mp="3kdpmyvp9l9wb">
              <Button variant="flat" color="default" onClick={() => setIsViewModalOpen(false)} data-id="element-5378" data-mp="1v0uise6xqk8e">
                Chiudi
              </Button>
              <Button onClick={handleViewToEdit} startContent={<Edit className="h-4 w-4" data-id="element-5380" data-mp="1wg6na2syhcds" />} data-id="element-5379" data-mp="1rkrdpn1ze2n6">
                Modifica
              </Button>
            </div>
          </div>}

        {viewItem && activeTab === 'improvements' && <div className="space-y-8" data-id="element-5381" data-mp="26f607xkr7u6l">
            <section data-id="element-5382" data-mp="18sfcj3n2d7em">
              <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-5383" data-mp="18sykpsmwwhfg">
                <Lightbulb className="h-4 w-4" data-id="element-5384" data-mp="1ds1rbhijivpj" /> Dettagli miglioramento
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5385" data-mp="1ipbl19cyptj6">
                <div data-id="element-5386" data-mp="1nhl9sm2ccnjv">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-5387" data-mp="1ni4rc1o2x9xd">
                    Codice
                  </label>
                  <p className="text-sm font-medium text-slate-900" data-id="element-5388" data-mp="pzuxoq4792tt">
                    {viewItem.number}
                  </p>
                </div>
                <div data-id="element-5389" data-mp="38a0nq5fnlrdm">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-5390" data-mp="38aii0wir9viw">
                    Data proposta
                  </label>
                  <p className="text-sm font-medium text-slate-900" data-id="element-5391" data-mp="2z9uamknvatez">
                    {viewItem.date || '-'}
                  </p>
                </div>
                <div className="col-span-full" data-id="element-5392" data-mp="2udddx22lr6qa">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-5393" data-mp="2pcfvqphlecos">
                    Oggetto
                  </label>
                  <p className="text-sm font-medium text-slate-900" data-id="element-5394" data-mp="2kjczuapcer5f">
                    {viewItem.subject || '-'}
                  </p>
                </div>
                <div className="col-span-full" data-id="element-5395" data-mp="2bluc2ykbdypu">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-5396" data-mp="2biyc74owozyr">
                    Descrizione
                  </label>
                  <p className="text-sm text-slate-700 bg-slate-50 rounded-lg p-3 border border-slate-100" data-id="element-5397" data-mp="21nmxunheturj">
                    {viewItem.description || '-'}
                  </p>
                </div>
                <div data-id="element-5398" data-mp="1wz42l9wfszt6">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-5399" data-mp="1wzdr0t1u2ywr">
                    Responsabile
                  </label>
                  <p className="text-sm font-medium text-slate-900" data-id="element-5400" data-mp="1mzd6x4w54eri">
                    {viewItem.responsible || '-'}
                  </p>
                </div>
                <div data-id="element-5401" data-mp="2artnfb08byop">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-5402" data-mp="2foaloy157tfi">
                    Stato
                  </label>
                  <Badge variant={viewItem.status === 'Sospesa' ? 'warning' : 'info'} data-id="element-5403" data-mp="21wno8uvgsev5">
                    {viewItem.status}
                  </Badge>
                </div>
              </div>
            </section>

            <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-5404" data-mp="2yeth04d9u8h4">
              <Button variant="flat" color="default" onClick={() => setIsViewModalOpen(false)} data-id="element-5405" data-mp="n02vot4w54zf">
                Chiudi
              </Button>
              <Button onClick={handleViewToEdit} startContent={<Edit className="h-4 w-4" data-id="element-5407" data-mp="wrqiuhuezzv3" />} data-id="element-5406" data-mp="wpmgw5g2taxg">
                Modifica
              </Button>
            </div>
          </div>}
      </Modal>

      {/* Create/Edit Modal */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title={selectedItem ? activeTab === 'nc' ? 'Modifica non conformità' : 'Modifica miglioramento' : activeTab === 'nc' ? 'Nuova non conformità' : 'Nuovo miglioramento'} size="2xl" data-id="element-5408" data-mp="43b7c5ahrzoi">
        <AnimatePresence mode="wait" data-id="element-5409" data-mp="1pcqhly84z33f">
          {saveSuccess ? <motion.div key="success" initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="flex flex-col items-center justify-center py-16" data-id="element-5410" data-mp="1kef7dmdxiqko">
              <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            type: 'spring',
            stiffness: 200,
            damping: 15
          }} className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mb-4" data-id="element-5411" data-mp="3nuae8iqgd95e">
                <CheckCircle2 className="w-12 h-12 text-green-500" data-id="element-5412" data-mp="fh3e8t0zpnip" />
              </motion.div>
              <p className="text-lg font-semibold text-slate-800" data-id="element-5413" data-mp="2c9dazorol92k">
                {activeTab === 'nc' ? 'Non conformità salvata con successo' : 'Miglioramento salvato con successo'}
              </p>
            </motion.div> : <motion.div key="form" initial={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} data-id="element-5414" data-mp="24xp78wcs5o2m">
              <div className="space-y-8" data-id="element-5415" data-mp="1uzj7akajas0e">
                {activeTab === 'nc' ? <>
                    <section data-id="element-5416" data-mp="2sn007rnw2e67">
                      <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-5417" data-mp="2sm8ed8k3fut4">
                        <AlertTriangle className="h-4 w-4" data-id="element-5418" data-mp="2noygd4in2ato" /> Dettagli non
                        conformità
                      </h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5419" data-mp="2dq0ts74rwrdb">
                        <Input label="Codice" value={formData.number || ''} onChange={e => setFormData({
                    ...formData,
                    number: e.target.value
                  })} disabled={!!selectedItem} data-id="element-5420" data-mp="2ds3np291r4nb" />
                        <Select label="Tipologia" value={formData.type || ''} onChange={e => setFormData({
                    ...formData,
                    type: e.target.value,
                    origin: ''
                  })} options={[{
                    value: 'Non conformità maggiore',
                    label: 'Non conformità maggiore'
                  }, {
                    value: 'Non conformità minore',
                    label: 'Non conformità minore'
                  }, {
                    value: 'Osservazione',
                    label: 'Osservazione'
                  }]} required data-id="element-5421" data-mp="k9eh9x1aibi9" />

                        {showOriginSelect && <div className="col-span-full animate-in fade-in slide-in-from-top-2" data-id="element-5422" data-mp="2d6i505b8cwyq">
                            <Select label="Origine" value={formData.origin || ''} onChange={e => setFormData({
                      ...formData,
                      origin: e.target.value
                    })} options={[{
                      value: 'Interna',
                      label: 'Interna'
                    }, {
                      value: 'Cliente (reclamo)',
                      label: 'Cliente (reclamo)'
                    }, {
                      value: 'Fornitore',
                      label: 'Fornitore'
                    }, {
                      value: 'Altro',
                      label: 'Altro'
                    }]} required data-id="element-5423" data-mp="1gic51vp96sqs" />
                          </div>}

                        <DatePicker label="Data rilevazione" value={formData.date || ''} onChange={e => setFormData({
                    ...formData,
                    date: e.target.value
                  })} data-id="element-5424" data-mp="1q7ma1rv2obxw" />
                        <Input label="Responsabile" value={formData.responsible || ''} onChange={e => setFormData({
                    ...formData,
                    responsible: e.target.value
                  })} data-id="element-5425" data-mp="3e0xurux2ugix" />
                        <div className="col-span-full" data-id="element-5426" data-mp="3j2de9ijlwez7">
                          <Textarea label="Descrizione non conformità / Osservazione" value={formData.description || ''} onChange={e => setFormData({
                      ...formData,
                      description: e.target.value
                    })} required data-id="element-5427" data-mp="3j1u8f078dh1j" />
                        </div>

                        <div className="col-span-full" data-id="element-5428" data-mp="2nwpjihycv9ej">
                          <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-5429" data-mp="2iw1ir4kbre74">
                            Allegati
                          </label>
                          <div className="border-2 border-dashed border-slate-300 rounded-xl p-6 text-center hover:bg-slate-50 cursor-pointer transition-colors group" data-id="element-5430" data-mp="3bjnxn8z0659a">
                            <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:bg-white transition-colors" data-id="element-5431" data-mp="36mxh6kjad7nc">
                              <Upload className="h-6 w-6 text-slate-400 group-hover:text-seform-orange" data-id="element-5432" data-mp="2wu8b656i8lze" />
                            </div>
                            <p className="text-sm text-slate-600 font-medium" data-id="element-5433" data-mp="3uc8e1qximhw7">
                              Clicca per caricare o trascina qui
                            </p>
                            <p className="text-xs text-slate-400 mt-1" data-id="element-5434" data-mp="ra6kix4pwph">
                              JPG, PNG, PDF fino a 10MB
                            </p>
                          </div>
                        </div>
                      </div>
                    </section>

                    <section data-id="element-5435" data-mp="fnhotdoz8o24">
                      <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-5436" data-mp="fkn3ljy52z7n">
                        <Lightbulb className="h-4 w-4" data-id="element-5437" data-mp="on4r01pj5xw8" /> Azione correttiva
                      </h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5438" data-mp="teeh13ezr38n">
                        <div className="col-span-full" data-id="element-5439" data-mp="tgh4pgso8ka7">
                          <Textarea label="Descrizione azione" value={formData.actionDescription || ''} onChange={e => setFormData({
                      ...formData,
                      actionDescription: e.target.value
                    })} data-id="element-5440" data-mp="ybwffzvdu02e" />
                        </div>
                        <Input label="Responsabile azione" value={formData.actionResponsible || ''} onChange={e => setFormData({
                    ...formData,
                    actionResponsible: e.target.value
                  })} data-id="element-5441" data-mp="3d73oat2yk0nq" />
                        <DatePicker label="Scadenza azione" value={formData.actionDeadline || ''} onChange={e => setFormData({
                    ...formData,
                    actionDeadline: e.target.value
                  })} data-id="element-5442" data-mp="3w569sxwarfgs" />
                        <Select label="Stato" value={formData.status || 'Aperta'} onChange={e => setFormData({
                    ...formData,
                    status: e.target.value
                  })} options={[{
                    value: 'Aperta',
                    label: 'Aperta'
                  }, {
                    value: 'Sospesa',
                    label: 'Sospesa'
                  }, {
                    value: 'Chiusa',
                    label: 'Chiusa'
                  }]} required data-id="element-5443" data-mp="1noismntgphxs" />
                      </div>
                    </section>
                  </> : <section data-id="element-5444" data-mp="1ruxs2g6751w">
                    <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-5445" data-mp="1smp312qigmd">
                      <Lightbulb className="h-4 w-4" data-id="element-5446" data-mp="3p3vs8zvbglps" /> Dettagli miglioramento
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5447" data-mp="3k52fxarrn0r7">
                      <Input label="Codice" value={formData.number || ''} onChange={e => setFormData({
                  ...formData,
                  number: e.target.value
                })} disabled={!!selectedItem} data-id="element-5448" data-mp="3k26kpu7ayq6g" />
                      <DatePicker label="Data proposta" value={formData.date || ''} onChange={e => setFormData({
                  ...formData,
                  date: e.target.value
                })} data-id="element-5449" data-mp="14cvfh3nummdw" />
                      <div className="col-span-full" data-id="element-5450" data-mp="302evyz53iw2t">
                        <Input label="Oggetto" value={formData.subject || ''} onChange={e => setFormData({
                    ...formData,
                    subject: e.target.value
                  })} required data-id="element-5451" data-mp="301wvfqbehvp3" />
                      </div>
                      <div className="col-span-full" data-id="element-5452" data-mp="3nsirskc1lrj9">
                        <Textarea label="Descrizione" value={formData.description || ''} onChange={e => setFormData({
                    ...formData,
                    description: e.target.value
                  })} required data-id="element-5453" data-mp="3nu3l66mmf4fj" />
                      </div>
                      <Input label="Responsabile" value={formData.responsible || ''} onChange={e => setFormData({
                  ...formData,
                  responsible: e.target.value
                })} data-id="element-5454" data-mp="ivhklih6tjfv" />
                      <Select label="Stato" value={formData.status || 'In valutazione'} onChange={e => setFormData({
                  ...formData,
                  status: e.target.value
                })} options={[{
                  value: 'In valutazione',
                  label: 'In valutazione'
                }, {
                  value: 'Sospesa',
                  label: 'Sospesa'
                }, {
                  value: 'Aperta',
                  label: 'Aperta'
                }, {
                  value: 'Chiusa',
                  label: 'Chiusa'
                }, {
                  value: 'Scartata',
                  label: 'Scartata'
                }]} required data-id="element-5455" data-mp="3w4dpzs5cpg6s" />
                    </div>
                  </section>}

                <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-5456" data-mp="2xv9w7lg51889">
                  <Button variant="flat" color="default" onClick={() => setIsModalOpen(false)} data-id="element-5457" data-mp="31w268gwu3h5l">
                    Annulla
                  </Button>
                  <Button onClick={handleSave} startContent={<Save className="h-4 w-4" data-id="element-5459" data-mp="3gs1mieu3knlt" />} data-id="element-5458" data-mp="3brdld0c5mqdv">
                    Salva
                  </Button>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
      </Modal>

      {/* Report Modal */}
      <Modal isOpen={isReportModalOpen} onClose={() => setIsReportModalOpen(false)} title="Invio report Non conformità" size="md" data-id="element-5460" data-mp="3ukhm15nsi3hz">
        <div className="space-y-6" data-id="element-5461" data-mp="8crdemrsii4j">
          <p className="text-sm text-slate-600" data-id="element-5462" data-mp="8byc41blokts">
            Stai per inviare il report della non conformità al cliente via
            email.
          </p>
          <Input label="Email destinatario" defaultValue="cliente@email.it" data-id="element-5463" data-mp="1ssfrcmdva4r6" />
          <Input label="Oggetto" defaultValue="Report Non Conformità #NC-2024/001" data-id="element-5464" data-mp="1nue7w0cj43f6" />
          <Textarea label="Messaggio" defaultValue="Gentile Cliente, in allegato il report della NC rilevata." data-id="element-5465" data-mp="1iyfnenubn5k1" />

          <div className="bg-slate-50 p-3 rounded border border-slate-200 flex items-center gap-2 text-sm text-slate-600" data-id="element-5466" data-mp="2bk8jyfp0xnyd">
            <Download className="h-4 w-4" data-id="element-5467" data-mp="26mp2l6x14v27" /> report_nc_001.pdf
          </div>

          <div className="flex justify-end gap-3 pt-4" data-id="element-5468" data-mp="21ufabk8fziwr">
            <Button variant="flat" color="default" onClick={() => setIsReportModalOpen(false)} data-id="element-5469" data-mp="1wwdo4qfpz3h2">
              Annulla
            </Button>
            <Button onClick={handleSendReport} startContent={<Mail className="h-4 w-4" data-id="element-5471" data-mp="2pjq94w68f389" />} data-id="element-5470" data-mp="2pl1g14uz4r3l">
              Invia report
            </Button>
          </div>
        </div>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={showDeleteDialog} onClose={() => setShowDeleteDialog(false)} title="Conferma eliminazione" size="sm" data-id="element-5472" data-mp="2f3pgyd8axg6g">
        <AnimatePresence mode="wait" data-id="element-5473" data-mp="253f6v1hkcovi">
          {deleteSuccess ? <motion.div key="success" initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3
        }} className="flex flex-col items-center justify-center py-12" data-id="element-5474" data-mp="2stj7czzgg8ia">
              <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            type: 'spring',
            stiffness: 150,
            damping: 15,
            delay: 0.1
          }} className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-4" data-id="element-5475" data-mp="3bsnf85f9fw8d">
                <CheckCircle2 className="w-10 h-10 text-green-500" data-id="element-5476" data-mp="1ew0ui308598p" />
              </motion.div>
              <p className="text-lg font-semibold text-slate-800" data-id="element-5477" data-mp="19wy1xi1fkvhm">
                Eliminato con successo
              </p>
            </motion.div> : <motion.div key="confirm" initial={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} data-id="element-5478" data-mp="h77kaz0lbbgr">
              <div className="space-y-6" data-id="element-5479" data-mp="r3kdlvs83naz">
                <div className="bg-red-50 p-4 rounded-lg border border-red-100 flex gap-3" data-id="element-5480" data-mp="r6q1x8t12l5n">
                  <AlertCircle className="h-5 w-5 text-red-600 flex-shrink-0" data-id="element-5481" data-mp="26n6xqsb8rn27" />
                  <div data-id="element-5482" data-mp="22izcx67wmr99">
                    <p className="text-sm text-red-700 font-medium" data-id="element-5483" data-mp="22lv5sg4wapqu">
                      Attenzione: questa azione è irreversibile.
                    </p>
                    <p className="text-sm text-red-600 mt-1" data-id="element-5484" data-mp="146ej4xyjh9iu">
                      L'elemento <strong data-id="element-5485" data-mp="19698uy6kvt2b">{itemToDelete?.number}</strong> verrà
                      eliminato definitivamente.
                    </p>
                  </div>
                </div>
                <div className="flex justify-end gap-3 pt-4" data-id="element-5486" data-mp="gidgg5o1knbc">
                  <Button variant="flat" color="default" onClick={() => setShowDeleteDialog(false)} data-id="element-5487" data-mp="gjybdwe9q89q">
                    Annulla
                  </Button>
                  <Button color="danger" onClick={confirmDelete} startContent={<Trash2 className="h-4 w-4" data-id="element-5489" data-mp="3txta6ty7bf17" />} data-id="element-5488" data-mp="u99wyy4p1e21">
                    Elimina
                  </Button>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
      </Modal>
    </Layout>;
}